import React from 'react';
import BaseTable from './BaseTable';
import ReadOnlyTableBody from './tbody/ReadOnlyTableBody';
import { SortOrder } from '../../types/sort/sort';

interface Header {
  label: string;
  sortable: boolean;
  sortKey: string;
  width: string;
}

interface HasId {
  id: number;
}

/** 構造的Ref（非推奨型は使わない） */
type DivRef = { current: HTMLDivElement | null };

interface ReadOnlyTableProps<T extends HasId> {
  headers: ReadonlyArray<Header>;
  items: T[];
  renderItem: (item: T) => React.JSX.Element;
  actionable: boolean;
  onSort?: (sortKey: string) => void;
  sortOrder?: SortOrder;
  activeSortColumn?: string;
  renderFooter?: () => React.ReactNode;
  /** 親から表の横スクロール要素を参照するための ref */
  scrollContainerRef?: DivRef;
  headerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
  footerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
}

const ReadOnlyTable = <T extends HasId>({
  headers,
  actionable,
  onSort,
  sortOrder,
  activeSortColumn,
  items,
  renderItem,
  renderFooter,
  scrollContainerRef,
  headerRef,
  footerRef,
}: ReadOnlyTableProps<T>) => {
  return (
    // 横スクロールはこのラッパに限定（ヘッダーは SyncedScrollHeader で追従）
    <div
      className="read-only-table-scroll"
      style={{ overflowX: 'auto', maxWidth: '100%' }}
      ref={scrollContainerRef as unknown as React.Ref<HTMLDivElement>}
    >
      <BaseTable
        headers={headers}
        actionable={actionable}
        onSort={onSort}
        sortOrder={sortOrder}
        activeSortColumn={activeSortColumn}
        headerRef={headerRef}
        footerRef={footerRef}
      >
        <ReadOnlyTableBody<T> items={items} renderItem={renderItem} />
        {renderFooter && <tfoot>{renderFooter()}</tfoot>}
      </BaseTable>
    </div>
  );
};

export default ReadOnlyTable;
